export interface FeatureConfig {
  key: string;
  name: string;
  description: string;
  path: string;
  groupId: string;
}

export const FEATURE_GROUPS = {
  caap:     process.env.REACT_APP_CAAP_GROUP_ID || '',
  deficits: process.env.REACT_APP_DEFICITS_GROUP_ID || '',
} as const;

export const FEATURE_CONFIG: FeatureConfig[] = [
  {
    key: 'caap',
    name: 'Collections Assignment',
    description: 'Automated collections agency assignment process (CAAP).',
    path: '/caap',
    groupId: FEATURE_GROUPS.caap,
  },
  {
    key: 'deficits',
    name: 'Deficits',
    description: 'Deficit management — coming soon.',
    path: '/deficits',
    groupId: FEATURE_GROUPS.deficits,
  },
];
